<template>
    <div class="w-root">
        <div class="w-views">
            <div class="secondary-menu media-watching video">

                <div class="secondary-menu-header">
                    <i class="back" @click="goBackToEvents"></i>
                    <div class="title" v-if="!dataLoading">{{ trans('pos_of_total', {position: videoPosition, total: videos.length}) }}</div>
                </div>

                <div class="secondary-menu-body">

                    <div class="w-swiper swiper-container">
                        <!-- Additional required wrapper -->
                        <div class="swiper-wrapper">
                            <!-- Slides -->
                            <div class="swiper-slide" v-if="!dataLoading" v-for="video in videos">
                                <div class="swiper-zoom-container b-profile__photo media">
                                    <VideoPlayer :poster="video.thumb_orig" :videoSource="video.video_url"></VideoPlayer>
                                </div>
                            </div>
                        </div>

                        <div class="w-slider__controls" v-if="!dataLoading"></div>
                    </div><!--swiper-container-->

                </div><!--secondary-menu-body-->
            </div><!--secondary-menu-->
        </div><!--w-views-->
    </div><!--w-root-->
</template>

<script>
    import VideoPlayer from '@buddy/views/widgets/VideoPlayer.vue'

    export default {
        mixins: [require('@general/lib/mixin').default],
        props: ['eventId', 'videoId'],
        components: {
            VideoPlayer
        },
        computed: {
            dataLoading() {
                return !this.event;
            },
            event() {
                return this.$store.getters.getEvent(this.eventId)
            },
            videos() {
                return this.event && this.userIsPro ? this.event.videos : this.event.videos.slice(0, 4);
            },
            video() {
                return this.videos && this.videos.find(el => el.id == this.videoId);
            },
            videoPosition() {
                return this.videos && this.videos.indexOf(this.video) + 1;
            }
        },
        methods: {
            goBackToEvents() {
                if (window.history.length > 1) {
                    this.$router.go(-1);
                } else {
                    this.$router.push(`/event/${this.eventId}`);
                }
            },
            onVideoChanged(newIndex) {
                this.videoId = this.videos[newIndex].id;
            },
            loadSwiperScript() {
                this.loadSwiper(this.videoPosition - 1, this.onVideoChanged);
            },
        },
        watch: {
            dataLoading: function (loading) {
                if (!loading) {
                    this.$nextTick(function(){
                        this.loadSwiperScript();
                    })
                }
            }
        },
        mounted() {
            if(!this.dataLoading) {
               this.loadSwiperScript();
            }
        }
    }
</script>